import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=5d11122d"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=5d11122d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlayerToc: require('/usr/src/app/components/player/toc.vue').default,PlayerEducator: require('/usr/src/app/components/player/educator.vue').default})
